import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import fanApi from "@/lib/fanApi";
import { useFanAuth } from "@/context/FanAuthContext";
import { FunnyLoader } from "@/components/FunnyLoader";

export default function FanAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useFanAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const finish = () => navigate(location.pathname + location.search, { replace: true });
    fanApi
      .post("/fan-auth/session", { session_id: sessionId })
      .then((res) => {
        localStorage.setItem("fan_token", res.data.session_token);
        setUser(res.data.user);
        toast.success(`¡Hola, ${res.data.user.name}!`);
      })
      .catch(() => toast.error("No se pudo iniciar sesión"))
      .finally(finish);
  }, [location, navigate, setUser]);

  return <FunnyLoader className="min-h-screen bg-black" />;
}
